import { useI18n } from '../../i18n/useI18n';
import { formatDateLabel, formatWeekday } from '../../utils/dates';
import { TaskColumn } from './TaskColumn';
import styles from './board.module.css';

export function DayColumn({ date, dateKey, tasks, isToday }) {
  const { lang, t } = useI18n();
  const headingId = `day-${dateKey}`;
  return (
    <section
      className={styles.column}
      aria-labelledby={headingId}
      data-zone="day"
      data-date={dateKey}
      data-length={tasks.length}
    >
      <header className={styles.header}>
        <p className={styles.date}>{formatDateLabel(date, lang)}</p>
        <h2 id={headingId} className={isToday ? `${styles.weekday} ${styles.todayName}` : styles.weekday}>
          {formatWeekday(date, lang)}
        </h2>
      </header>
      <TaskColumn
        tasks={tasks}
        scope={`day-${dateKey}`}
        loc={{ zone: 'day', date: dateKey }}
        placeholder={t('task.add')}
      />
    </section>
  );
}
